import FileSaver from 'file-saver'
import axios from '../../../utils/api'
import { CLEAR_CADASTRO, SET_CADASTRO_ORIGINAL } from '../../mutation-types'

const state = {
  cadastroOriginal: {}
}

const getters = {
  cadastroOriginal: state => state.cadastroOriginal
}

function formatTipoCadastro (tipo) {
  switch (tipo) {
    case 'PERMUTA':
      return 'Permuta'
    case 'AFORAMENTO':
      return 'Aforamento'
    case 'TRANSFERENCIA_DIREITOS':
      return 'Transferência de Direitos'
    case 'INFORMACOES':
      return 'Informação'
    case 'AREAS_PATRIMONIAIS':
      return 'Áreas Patrimoniais'
    default:
      return '-'
  }
}

const mutations = {
  [CLEAR_CADASTRO] (state, emptyCadastro) {
    Object.assign(state, emptyCadastro)
  },
  [SET_CADASTRO_ORIGINAL] (state, cadastroOriginal) {
    Object.assign(state.cadastroOriginal, cadastroOriginal)
  }
}

const actions = {
  async salvarCadastro ({ commit }, cadastro) {
    const result = await axios({
      method: 'POST',
      url: 'central/cadastro/salvar',
      data: {
        ...cadastro
      }
    })

    return result
  },

  async finalizarCadastro ({ commit }, idCadastro) {
    await axios({
      method: 'GET',
      url: `central/cadastro/finalizar/${idCadastro}`,
      timeout: 180000,
      responseType: 'blob'
    })
  },

  async validarPonto ({ commit }, latLng) {
    const result = await axios({
      method: 'GET',
      url: `central/cadastro/validarPonto/${latLng.lat}/${latLng.lng}`,
      timeout: 180000,
      error: true
    })

    return result
  },

  async findByIdCadastro ({ commit }, idCadastro) {
    const result = await axios({
      method: 'GET',
      url: `central/cadastro/${idCadastro}`
    })

    return result
  },

  /************/

  async findCadastroOriginal ({ commit }, id) {
    try {
      const cadastroOriginal = await axios({
        method: 'GET',
        url: `cadastro/findCadastroOriginalById/${id}`
      })
      commit('SET_CADASTRO_ORIGINAL', cadastroOriginal)
      return cadastroOriginal
    } catch (error) {
      throw error
    }
  },

  async finalizar ({ commit }, { idCadastro, emptyCadastro }) {
    try {
      await axios({
        method: 'PUT',
        url: `cadastro/finalizar/${idCadastro}`
      })
      await commit('CLEAR_CADASTRO', emptyCadastro)
    } catch (error) {
      throw error
    }
  },

  async exportar ({ commit }, cadastro) {
    // eslint-disable-line
    try {
      const file = await axios({
        method: 'GET',
        url: `cadastro/exportar/${cadastro.id}`,
        responseType: 'blob'
      })
      const nomeComprovante = `Comprovante de envio - ${formatTipoCadastro(
        cadastro.tipo
      )} - ${cadastro.interessado.pessoa.nome}`
      FileSaver.saveAs(file, nomeComprovante)
      return file
    } catch (error) {
      throw error
    }
  },

  async downloadDocumentoOriginal ({ commit }, params) {
    let owner = ''
    let rota = ''
    switch (params.owner) {
      case 'CADASTRANTE':
        owner = 'cadastrante'
        rota = `cadastro/${params.idCadastro}/documento/${owner}/${params.idDocumento}?versao=${params.versao}`
        break
      case 'INTERESSADO':
        owner = 'interessado'
        rota = `cadastro/${params.idCadastro}/documento/${owner}/${params.idDocumento}?versao=${params.versao}`
        break
      case 'INTERESSADOS':
        owner = 'interessados'
        rota = `cadastro/${params.idCadastro}/documento/${owner}/${params.idDocumento}/${params.idInteressado}?versao=${params.versao}`
        break
      case 'BENEFICIARIO':
        owner = 'beneficiario'
        rota = `cadastro/${params.idCadastro}/documento/${owner}/${params.idDocumento}/${params.idBeneficiario}?versao=${params.versao}`
        break
      case 'GEO-BENEFICIARIO':
        owner = 'beneficiario-geo'
        rota = `cadastro/${params.idCadastro}/documento/${owner}/${params.idDocumento}/${params.idBeneficiario}?versao=${params.versao}`
        break
      case 'DEPENDENTE':
        owner = 'dependente'
        rota = `cadastro/${params.idCadastro}/documento/${owner}/${params.idDocumento}/${params.idDependente}?versao=${params.versao}`
        break
      case 'IMOVEL':
        owner = 'imovel'
        rota = `cadastro/${params.idCadastro}/documento/${owner}/${params.idDocumento}?versao=${params.versao}`
        break
      case 'GEO':
        owner = 'georreferenciamento'
        rota = `cadastro/${params.idCadastro}/documento/${owner}/${params.idDocumento}?versao=${params.versao}`
        break
      case 'MEMBROS_DA_COMUNIDADE':
        owner = 'membrosComunidade'
        rota = `cadastro/${params.idCadastro}/documento/${owner}/${params.idDocumento}/${params.idMembroComunidade}?versao=${params.versao}`
        break
      case 'SOCIO_REPRESENTANTE':
        owner = 'socio'
        rota = `cadastro/${params.idCadastro}/documento/${owner}/${params.idDocumento}/${params.idSocio}?versao=${params.versao}`
        break
      case 'SOLICITACAO':
        owner = 'solicitacao'
        rota = `cadastro/${params.idCadastro}/documento/${owner}/${params.idDocumento}?versao=${params.versao}`
        break
      case 'OFICIO':
        owner = 'oficio'
        rota = `cadastro/${params.idCadastro}/documento/${owner}/${params.idDocumento}?versao=${params.versao}`
        break
      case 'DESTINACAO_USO_IMOVEL_PRODUTIVIDADE':
        owner = 'destinacaoUsoImovel,produtividade'
        rota = `cadastro/${params.idCadastro}/documento/${owner}/${params.idDocumento}?versao=${params.versao}`
        break
      default:
        owner = ''
        break
    }

    rota += `&isCadastroPendente=${params.isCadastroPendente}`

    await axios({
      method: 'GET',
      url: rota,
      responseType: 'blob'
    })
  },

  async downloadDocumentoCentral ({ commit }, params) {
    // eslint-disable-line
    let rota = ''
    switch (params.owner) {
      case 'beneficiario':
        rota = `central/cadastro/${params.idCadastro}/documento/${params.owner}/${params.idDocumento}/${params.idBeneficiario}`
        break
      case 'membrosComunidade':
        rota = `central/cadastro/${params.idCadastro}/documento/${params.owner}/${params.idDocumento}/${params.idMembroComunidade}`
        break
      case 'socio':
        rota = `central/cadastro/${params.idCadastro}/documento/${params.owner}/${params.idDocumento}/${params.idSocio}`
        break
      default:
        rota = `central/cadastro/${params.idCadastro}/documento/${params.owner}/${params.idDocumento}`
        break
    }

    await axios({
      method: 'GET',
      url: rota,
      responseType: 'blob'
    })
  },

  async emitirSegundaVia ({ commit }, params) {
    // eslint-disable-line
    await axios({
      method: 'GET',
      url: 'publico/cadastro/comprovante/' + params.protocoloCadastro,
      responseType: 'blob'
    })
  },

  async buscarFotosReurb ({ commit }, getFotosForm) {
    // eslint-disable-line
    const fotos = await axios({
      method: 'POST',
      url: 'foto/getFotosView',
      data: getFotosForm,
      loader: false
    })
    return fotos
  },

  async toggleAceitarTermo (context, cadastroId) {
    await axios({
      method: 'GET',
      url: `cadastro/aceiteTermoCompromisso/${cadastroId}`
    })
  },

  calculoIntersectGeoCentral ({ commit }, data) {
    return axios({
      method: 'post',
      data,
      url: 'central/cadastro/calcularGeo',
      loader: false,
      error: true
    })
  },

  findByUsuarioAndTipo ({ commit }, dados) {
    return axios({
      method: 'post',
      data: dados,
      url: `central/cadastro/list`,
      loader: false,
      error: true
    })
  },

  updateBeneficiariosByProtocolo ({ commit }, dados) {
    return axios({
      method: 'PATCH',
      data: dados.beneficiarios,
      url: `central/cadastro/updateBeneficiarios/${dados.protocolo}`,
      loader: true,
      error: true
    })
  },

  validateBeneficiario ({ commit }, dados) {
    return axios({
      method: 'GET',
      url: `central/cadastro/isUniqueBeneficiario?cpfBeneficiario=${dados.cpfBeneficiario}&cpfConjuge=${dados.cpfConjuge}`,
      loader: false,
      error: true
    })
  },

  getInteressado ({ commit }, protocoloProcesso) {
    return axios({
      method: 'GET',
      url: `central/cadastro/getInteressado/${protocoloProcesso}`,
      loader: true,
      error: true
    })
  },

  getImovel ({ commit }, protocoloProcesso) {
    return axios({
      method: 'GET',
      url: `central/cadastro/getImovel/${protocoloProcesso}`,
      loader: true,
      error: true
    })
  },

  findCadastroById ({ commit }, id) {
    return axios({
      method: 'GET',
      url: `publico/cadastro/findById/${id}`,
      loader: true,
      error: true
    })
  },

  async finalizarRetificacaoProcessoFisico ({ commit }, protocolo) {
    await axios({
      method: 'post',
      url: `central/cadastro/encerrar/retificacao/processo/fisico/${protocolo}`
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/centralInteressado/cadastro.js